import { shrpaApi } from "@/repos/axios";
import { getCalendarId } from "@logic/calendarManager";

export default class SocialIntegrationRepo {
  static async createPortalLink(
    customerId: string,
    returnUrl: string,
    selectedPlatforms: ReadonlyArray<string> = [],
    options?: { forceStandardScope?: boolean }
  ): Promise<string> {
    const calendarId = await getCalendarId(customerId);
    const url = `/social-account/manage/${encodeURIComponent(customerId)}/${encodeURIComponent(calendarId)}/portal-link`;
    const { data } = await shrpaApi.post<string>(
      url,
      {
        returnUrl,
        selectedPlatforms: [...selectedPlatforms],
        forceStandardScope: options?.forceStandardScope === true,
      },
      {
        params: {
          returnUrl,
          ...(selectedPlatforms.length > 0 ? { selectedPlatforms: selectedPlatforms.join(",") } : {}),
        },
      }
    );
    return data;
  }

  static async reportConnectPrepIssue(
    customerId: string,
    payload: { issueId: string; issueText: string; selectedPlatforms: ReadonlyArray<string>; clickedStandardScopeRetry?: boolean }
  ): Promise<void> {
    const calendarId = await getCalendarId(customerId);
    const url = `/social-account/manage/${encodeURIComponent(customerId)}/${encodeURIComponent(calendarId)}/connect-prep-issue`;
    await shrpaApi.post(url, {
      issueId: payload.issueId,
      issueText: payload.issueText,
      selectedPlatforms: [...payload.selectedPlatforms],
      clickedStandardScopeRetry: payload.clickedStandardScopeRetry === true,
    });
  }

  static async getSocialAccounts(customerId: string): Promise<string> {
    const calendarId = await getCalendarId(customerId);
    const url = `/social-account/manage/${encodeURIComponent(customerId)}/${encodeURIComponent(calendarId)}/social-accounts`;
    const { data } = await shrpaApi.get<string>(url);
    return data;
  }
}
